const e = {
  name: "RevenueAccelerate",
  dimensions: { width: 24, height: 24 },
  content: `
    <svg fill="currentColor">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.90436 1.86797C11.0617 0.710676 12.9433 0.710676 14.1006 1.86797L22.132 9.89942C23.2893 11.0567 23.2893 12.9383 22.132 14.0956L14.1006 22.1271C12.9433 23.2844 11.0617 23.2844 9.90436 22.1271L1.8729 14.0956C0.709107 12.9318 0.701774 11.0584 1.87493 9.8974L9.90436 1.86797ZM12.6864 3.28219C12.3101 2.90594 11.6948 2.90594 11.3186 3.28219L10.0075 4.59327L16.7071 11.2928C17.0976 11.6834 17.0976 12.3165 16.7071 12.707L10.0099 19.4043L11.3186 20.7129C11.6948 21.0891 12.3101 21.0891 12.6864 20.7129L20.7178 12.6814C21.0941 12.3052 21.0941 11.6899 20.7178 11.3136L12.6864 3.28219ZM6.50745 8.0933L8.59327 6.00748L14.5858 12L8.59573 17.99L6.50993 15.9042L9.70706 12.7071C10.0976 12.3166 10.0976 11.6834 9.70706 11.2929L6.50745 8.0933ZM5.09324 9.50751L3.28261 11.3181C2.90507 11.6909 2.89853 12.2928 3.28712 12.6814L5.09572 14.49L7.58574 12L5.09324 9.50751Z" />
    </svg>

  `
};
export {
  e as RevenueAccelerate
};
